export { createSelector } from './create-selector';



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/core/utils/store-helpers/index.ts